import { isAssessment } from '../../TeacherDashboardV3/data/assessments';

// Where curriculum assessments sit in the student's lists (2026-10-18). An
// assessment is often given "in class today" and closes at the end of the
// day, so a student with old overdue sets never saw it: overdue items sort
// first. An OPEN, unfinished assessment now leads; nothing else moves.

// Open = not closed (by the teacher or at its due) and not finished. The list
// API already hides sets whose start time has not come.
export const isOpenAssessment = (hw) => isAssessment(hw) && !hw.done && !hw.closed;

// Soonest end first; equal or unknown ends keep their order (Array.sort is stable).
const byEnd = (endOf) => (a, b) => {
  const x = endOf(a);
  const y = endOf(b);
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// The items `lead` picks move to the front, soonest end first among them.
// Every other item keeps exactly the order it came in.
export function leadWith(list, lead, endOf) {
  const front = [];
  const rest = [];
  for (const it of list || []) (lead(it) ? front : rest).push(it);
  return [...front.sort(byEnd(endOf)), ...rest];
}

// Up next on the student home: rows are { end, openAssessment, ... }. Open
// assessments first (soonest due first), then every other row in the order Up
// next has always used (soonest due first, undated last).
export function sortUpNext(items) {
  const byDue = [...(items || [])].sort((x, y) => x.end - y.end);
  return leadWith(byDue, (it) => !!it.openAssessment, (it) => it.end);
}
